import { Navigation, type NavigationAction } from '@atlas/ui-kit'

export interface StepFooterCta {
	label: string
	onPress: () => void
	isDisabled?: boolean
	/** While the step's move is in flight; the button stays put and stops accepting presses. */
	isPending?: boolean
}

const actionOf = (cta: StepFooterCta | null | undefined): NavigationAction | undefined =>
	cta ? { label: cta.label, onPress: cta.onPress, isDisabled: cta.isDisabled || cta.isPending } : undefined

/**
 * The bar every work-order step screen ends with, the kit's Navigation: back on the left, the
 * step's action on the right, and beside it, on a step that defines one, a secondary action such
 * as Save Draft. Sticky to the bottom of the app's scroll container, so it must be the last
 * element in the page flow rather than nested in a shorter column.
 */
export function WorkOrderStepFooter({
	onBack,
	cta,
	secondary,
}: {
	onBack: () => void
	/** Absent when the signed-in user has no move to make on this step. */
	cta?: StepFooterCta | null
	/** Shown left of the action, outlined; absent on most steps. */
	secondary?: StepFooterCta | null
}) {
	return (
		<div className="atlas-root sticky bottom-0 z-10 -mx-6 mt-8">
			<Navigation
				onBack={onBack}
				backLabel="Back to work orders"
				secondaryAction={actionOf(secondary)}
				primaryAction={actionOf(cta)}
			/>
		</div>
	)
}
